import axios from "axios"

export const createDocument = (entityId, formData) =>
  axios.post(`/api/v2/project/${entityId}/document`, formData)

export const createPictogram = (entityId, formData) =>
  axios.post(`/api/v2/project/${entityId}/pictogram`, formData)

/**
 * Sube una nueva versión del DXF de un Document existente, asociado a un pictograma.
 * Endpoint: POST /api/v2/document/{document_id}/add_version/pictogram/{pictogramId}
 */
export const addDocumentVersionForPictogram = (documentId, pictogramId, formData) =>
  axios.post(`/api/v2/document/${documentId}/add_version/pictogram/${pictogramId}`, formData)
